import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "../methods/baseQueryWithAuth";
import { reducerPaths } from "../../app/reducerPaths";

export const carEstimateApi = createApi({
  reducerPath: reducerPaths.carEstimateApi,
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    updateFirmPrice: builder.mutation({
      query: ({ formData, vehicleId }) => ({
        url: `/updatefirmprice/${vehicleId}/normaledit`,
        method: "POST",
        body: formData,
      }),
    }),
  }),
});

export const { useUpdateFirmPriceMutation } = carEstimateApi;
